import styled from '@emotion/styled';
import { TextField } from '@mui/material';

export const StyledSearchInput = styled(TextField)(
  ({ theme, paddingblock }) => ({
    flexGrow: '1',
    width: '100%',

    input: {
      fontSize: '18px',
      paddingInline: '0',
      paddingBlock: paddingblock ? paddingblock : 'unset',
      //   padding: 'unset',

      //   '&::placeholder': {
      //     color: theme.palette.blue.placeholder,
      //   },
    },

    fieldset: {
      border: 'unset',
    },
  }),
);
